import { buildCrossDomainCvNavigation } from '@/helpers/crossDomainCv';

const NAVIGABLE_PROTOCOLS = ['http:', 'https:'];

// 遷移してよい URL か。CTA の URL は API（GMC の商品 link を含む）から来るので信用しない。
// `javascript:` などに遷移すると、顧客サイトのオリジンでスクリプトが動いてしまう。
// ブラウザと同じ URL パーサーで解釈し（`java\tscript:` のような偽装も正規化される）、
// http / https だけを許可する。相対 URL はページ基準で解決するので許可される。
const isNavigableUrl = (value) => {
  if (value === null || value === undefined) return false;
  const raw = String(value).trim();
  if (raw === '') return false;

  try {
    return NAVIGABLE_PROTOCOLS.includes(new URL(raw, window.location.href).protocol);
  } catch {
    return false;
  }
};

export const ctaTriggerAndNavigate = (cvUrl, cvParams = null) => {
  if (!isNavigableUrl(cvUrl)) return;

  if (!cvParams) {
    window.location.href = cvUrl;
    return;
  }

  const navigation = buildCrossDomainCvNavigation(cvUrl, cvParams);
  if (!isNavigableUrl(navigation.url)) return;

  navigation.cleanupSourceLogs();
  window.location.href = navigation.url;
}
